import React from 'react';
import './BestPriceDisplay.scss';

const BestPriceDisplay = ({ unitPrice, autoDiscounts, paymentMethods, show, isItem = false }) => {
  if (!show || !unitPrice || !paymentMethods?.length) return null;

  // 1. Buscamos la escala de mayor porcentaje (la mejor de todas)
  const maxTier = autoDiscounts?.length 
    ? [...autoDiscounts].sort((a, b) => parseFloat(b.percentage) - parseFloat(a.percentage))[0]
    : null;

  // 2. Calculamos sobre todos los medios cuál da el precio más bajo usando esa escala (si el medio lo permite)
  const bestPromo = paymentMethods.reduce((acc, pm) => {
    let price = parseFloat(unitPrice);
    
    // Si el medio permite descuento automático, usamos la MEJOR escala disponible (independiente del unitPrice)
    if ((pm.allow_discount == 1 || pm.allow_discount === true) && maxTier) {
      price *= (1 - parseFloat(maxTier.percentage) / 100);
    }

    const final = price * (1 - (parseFloat(pm.percent) || 0));
    const off = Math.round((1 - final / parseFloat(unitPrice)) * 100);

    if (!acc || final < acc.final) {
      return { final, name: pm.name, off };
    }
    return acc;
  }, null);

  if (!bestPromo || bestPromo.off <= 0) return null;

  return (
    <div className={`best-price-display ${isItem ? 'is-item-view' : 'is-product-view'}`}>
      <div className="best-price-main">
        {`$${bestPromo.final.toLocaleString('de-DE')} con ${bestPromo.name}`}
      </div>
      <div className="best-price-off">
        {`(${bestPromo.off}% OFF ${isItem ? '' : 'APLICANDO DESCUENTOS'})`}
      </div>
    </div>
  );
};

export default BestPriceDisplay;